import React from 'react'
import { AdditionalInsuredModel } from '../../models/user-models/AdditionalInsuredModel'
import FlexView from 'react-flexview/lib'
import { default as AICircle } from '../../assets/ai.svg'

interface AdditionalInsuredPolicyViewProps {
    ai: AdditionalInsuredModel
}

export const AdditionalInsuredPolicyView = ({ai}: AdditionalInsuredPolicyViewProps) => {

    return (<FlexView vAlignContent={'center'} className="margin-top-basic">
        <img src={AICircle} className="margin-right-small" />
        <div>
            <div className="text-small black text-overflow-elipsis-small">{ai.name}</div>
            <div className="text-tiny gray">{ai.state}</div>
        </div>
    </FlexView>)
}